import { trackerMap } from './key';

import type { TrackerMap } from './key';

import { pascalCase } from 'change-case';

export { trackerMap, TrackerMap };
/**
 * @param {string} NSKey 命名空间
 * @param {string} id 埋点id
 * @param {*} params 其他参数
 */
export type idType<T extends keyof typeof trackerMap> = (typeof trackerMap)[T][number];
export function TK<T extends keyof TrackerMap>(NSKey: T, id: idType<T>, params: object = {}) {
    const value = `${pascalCase(NSKey)}${pascalCase(id)}`;    
    window.aplus_queue.push({
        action: 'aplus.record',
        arguments: [`${value}`, 'CLK', { ...params }],
    });
}

export function setupTracker() {
    (function (w, d, s, q, i) {
        w[q] = w[q] || [];
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s) as HTMLScriptElement;
        j.async = true;
        j.id = 'beacon-aplus';
        j.src = 'https://d.alicdn.com/alilog/mlog/aplus/' + i + '.js';
        f.parentNode?.insertBefore(j, f);
    })(window, document, 'script', 'aplus_queue', '203467608');

    //集成应用的appKey
    window.aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['appKey', '64b65f65a1a164591b4f8eaa'],
    });

    window.aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['aplus-waiting', 'MAN'],
    });

    //是否开启调试模式
    window.aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['DEBUG', false],
    });
}

export function H5SendPv(page: any) {
    window.aplus_queue.push({
        action: 'aplus.sendPV',
        arguments: [{ is_auto: false }, { page }],
    });
}

export function H5ShareTracker(params: any) {
    window.aplus_queue.push({
        action: 'aplus.sendPV',
        arguments: [{ is_auto: false }, params],
    });
}
